<app-theme-container>
  @if (query$ | async; as query) {
    <app-program-initiation
      [query]="query"
      [rows]="rows$ | async"
      [totalCount]="totalCount$ | async"
      [loading]="loading$ | async"
      [emptyMessage]="emptyMessage$ | async"
      [filterOptions]="filterOptions$ | async"
      [accountNameSuggestions]="accountNameSuggestions$ | async"
      [accountMappings]="accountMappings$ | async"
      [allCarriers]="allCarriers$ | async"
      [isSaving]="isSaving$ | async"
      [initiatingOppId]="initiatingOppId$ | async"
      [showAll]="showAll$ | async"
      (filtersChange)="onFiltersChange($event)"
      (accountNameSearch)="onAccountNameSearch($event)"
      (showAllChange)="onShowAllChange($event)"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (initiate)="onInitiate($event)"
      (updateSFMapping)="onUpdateSFMapping($event)"
    />
  }
</app-theme-container>
